import { Button, Card, InputNumber, Space, Typography, notification } from '@pankod/refine-antd';
import { useEffect, useState } from 'react';
import { getErpOption, setErpOption } from 'services/erp-options';
import { parseVatRatePercent, VAT_RATE_OPTION } from 'utilities/sale-vat';

// The organization VAT rate (Stitches S4). Shown only while `sale.vatRate` is on; each new sale
// copies the rate, so changing it never changes a sale already made.
export const VatRateSettingCard = () => {
  const [vatRatePercent, setVatRatePercent] = useState<number>(0);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    getErpOption(VAT_RATE_OPTION)
      .then((value) => setVatRatePercent(parseVatRatePercent(value)))
      .catch(() => setVatRatePercent(0));
  }, []);

  const saveVatRate = async () => {
    setIsSaving(true);
    try {
      await setErpOption(VAT_RATE_OPTION, String(vatRatePercent));
      notification.success({
        message: 'Success',
        description: `VAT rate set to ${vatRatePercent}% for new sales`,
      });
    } catch (err: any) {
      notification.error({ message: 'Failed', description: err?.message ?? 'Failed to save VAT rate' });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card
      title="VAT"
      size="small"
      style={{ marginTop: 16 }}
      headStyle={{ fontSize: '16px', padding: '16px 24px', fontWeight: 'bold' }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px 0',
        }}
      >
        <div>
          <Typography.Text strong>VAT rate for new sales</Typography.Text>
          <div>
            <Typography.Text type="secondary">
              Added on top of the actual price. Existing sales keep the rate they were made with.
            </Typography.Text>
          </div>
        </div>
        <Space>
          <InputNumber
            min={0}
            max={100}
            step={0.5}
            value={vatRatePercent}
            addonAfter="%"
            onChange={(value) => setVatRatePercent(parseVatRatePercent(value))}
          />
          <Button type="primary" loading={isSaving} onClick={saveVatRate}>
            Save
          </Button>
        </Space>
      </div>
    </Card>
  );
};
